export const useCart = () => {
  const anonymousUser = useAnonymousUser()
  const modals = useModalManager()

  const authStore = useAuthStore()
  const checkoutStore = useCheckoutStore()

  const performCheckoutResetCheck = () => {
    const anonymousUserId = anonymousUser.getToken()

    if (!authStore.isAuthenticated && checkoutStore.owner !== anonymousUserId) {
      checkoutStore.reset()
      modals.show('CartEmptied')
      return true
    }

    return false
  }

  const goToCart = (_draftId?: string) => {
    const draftId = _draftId || checkoutStore.draftId
    if (!draftId) {
      customNavigateTo({
        name: 'warenkorb-einzelheiten',
      })
    } else {
      const isCheckoutResetTriggered = performCheckoutResetCheck()

      if (isCheckoutResetTriggered)
        return

      customNavigateTo({
        name: 'warenkorb-einzelheiten-draftId',
        params: { draftId },
      })
    }
  }

  return {
    goToCart,
  }
}
